import useMessagesAPIClient from "../../api/messages/hooks/useMessagesAPIClient";

const useSubmitGeneralFeedback = () => {
  const { sendReply } = useMessagesAPIClient();

  const submit = async (params) => {
    try {
      // Send general feedback as a message to admin
      await sendReply(params.feedback);
      return { success: true };
    } catch (error) {
      console.error("Error submitting feedback:", error);
      return { success: false, error: error.message };
    }
  };

  return { submit };
};

export default useSubmitGeneralFeedback;
